import { useUser } from '@utmb/contexts/AuthContext';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';
import { ReactElement } from 'react';
import styles from './my-loyalty-level.module.scss';
import { LoyaltyLevelName } from '@utmb/types/view/LoyaltyLevelEnum';

interface MyLoyaltyLevelProps {
    hideLabel?: boolean;
    forceLevel?: LoyaltyLevelEnum;
    className?: string;
}

const MyLoyaltyLevel = (props: MyLoyaltyLevelProps): ReactElement => {
    const { me } = useUser();
    const loyalty = me?.loyalty || false;

    const { hideLabel, forceLevel, className } = props;

    const level = forceLevel ?? loyalty;

    return level !== false ? (
        <div className={[styles.loyalty_display, className].filter(Boolean).join(' ')}>{!hideLabel && LoyaltyLevelName[level]}</div>
    ) : (
        <></>
    );
};

export default MyLoyaltyLevel;
